import { IApiClientOptions } from 'core';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import {
    ComponentVersionDto,
    ComponentVersionMessageResponseDto,
    CreateComponentVersionRequest,
    UpdateComponentVersionRequest,
} from 'dto/raptor-component-version.dto';
import { transform } from 'dto/transformer';

export class RaptorComponentVersionsApiClient extends AssureBaseApiClient {
    constructor(options: IApiClientOptions) {
        super('raptorComponentVersions', options);
    }

    protected getRootPath(): string {
        return 'raptor/component-versions';
    }

    public async createComponentVersion(
        accountId: number,
        componentUuid: string,
        params: CreateComponentVersionRequest,
    ): Promise<ComponentVersionDto> {
        const response = await this.send<{ componentVersion: ComponentVersionDto }>(
            HTTP_METHOD.POST,
            this.getRequestOptionsWithAccountId(
                accountId,
                '',
                params,
                `componentUuid=${encodeURIComponent(componentUuid)}`,
            ),
        );
        return transform(ComponentVersionDto, response.componentVersion);
    }

    public async getComponentVersion(accountId: number, uuid: string): Promise<ComponentVersionDto> {
        const response = await this.send<{ componentVersion: ComponentVersionDto }>(
            HTTP_METHOD.GET,
            this.getRequestOptionsWithAccountId(accountId, uuid),
        );
        return transform(ComponentVersionDto, response.componentVersion);
    }

    public async updateComponentVersion(
        accountId: number,
        uuid: string,
        params: UpdateComponentVersionRequest,
    ): Promise<ComponentVersionDto> {
        const response = await this.send<{ componentVersion: ComponentVersionDto }>(
            HTTP_METHOD.PUT,
            this.getRequestOptionsWithAccountId(accountId, uuid, params),
        );
        return transform(ComponentVersionDto, response.componentVersion);
    }

    public async deleteComponentVersion(accountId: number, uuid: string): Promise<ComponentVersionMessageResponseDto> {
        const response = await this.send<{ message: string }>(
            HTTP_METHOD.DELETE,
            this.getRequestOptionsWithAccountId(accountId, uuid),
        );
        return transform(ComponentVersionMessageResponseDto, response);
    }

    public async publishComponentVersion(accountId: number, uuid: string): Promise<ComponentVersionMessageResponseDto> {
        const response = await this.send<{ message: string }>(
            HTTP_METHOD.PUT,
            this.getRequestOptionsWithAccountId(accountId, `${uuid}/publish`),
        );
        return transform(ComponentVersionMessageResponseDto, response);
    }
}
